module.exports = __webpack_public_path__ + "static/media/A-friend.7f618e29.png";